import * as i1 from '@angular/common/http';
import * as i0 from '@angular/core';
import { inject, numberAttribute, Component, ChangeDetectionStrategy, Input, HostBinding } from '@angular/core';
import { NgDocCacheInterceptor } from '@ng-doc/ui-kit/interceptors';
import { NG_DOC_ASSETS_PATH, NG_DOC_CUSTOM_ICONS_PATH } from '@ng-doc/ui-kit/tokens';
import { Subject, of } from 'rxjs';
import { startWith, switchMap, catchError } from 'rxjs/operators';
let NgDocIconComponent = /*#__PURE__*/(() => {
  class NgDocIconComponent {
    constructor(elementRef, httpClient) {
      this.elementRef = elementRef;
      this.httpClient = httpClient;
      /** Icon name */
      this.icon = '';
      /** Custom icon name, if not set, `icon` will be used */
      this.customIcon = '';
      /** Icon size */
      this.size = 16;
      this.reload$ = new Subject();
      this.assetsPath = inject(NG_DOC_ASSETS_PATH, {
        optional: true
      }) ?? '';
      this.customIconsPath = inject(NG_DOC_CUSTOM_ICONS_PATH, {
        optional: true
      }) ?? '';
    }
    ngOnChanges() {
      this.reload$.next();
    }
    ngOnInit() {
      this.reload$.pipe(startWith(null), switchMap(() => this.httpClient.get(this.href, {
        responseType: 'text',
        params: {
          [NgDocCacheInterceptor.TOKEN]: 'true'
        }
      }).pipe(catchError(e => {
        console.error(e);
        return of('');
      })))).subscribe(svg => this.elementRef.nativeElement.innerHTML = svg);
    }
    get href() {
      return this.customIcon ? `${this.customIconsPath}/${this.customIcon}.svg#${this.customIcon}` : `${this.assetsPath}/icons/${this.size}/${this.icon}.svg#${this.icon}`;
    }
    static {
      this.ɵfac = function NgDocIconComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocIconComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.HttpClient));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgDocIconComponent,
        selectors: [["ng-doc-icon"]],
        hostVars: 3,
        hostBindings: function NgDocIconComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("data-ng-doc-icon", ctx.icon)("data-ng-doc-custom-icon", ctx.customIcon)("data-ng-doc-size", ctx.size);
          }
        },
        inputs: {
          icon: "icon",
          customIcon: "customIcon",
          size: [2, "size", "size", numberAttribute]
        },
        standalone: true,
        features: [i0.ɵɵInputTransformsFeature, i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        decls: 0,
        vars: 0,
        template: function NgDocIconComponent_Template(rf, ctx) {},
        styles: ["[_nghost-%COMP%]{display:inline-flex;align-items:center;justify-content:center;width:var(--ng-doc-icon-width, 16px);height:var(--ng-doc-icon-height, 16px);color:var(--ng-doc-icon-color, var(--ng-doc-text));vertical-align:sub}[_nghost-%COMP%]   svg[_ngcontent-%COMP%]{vertical-align:top}[data-ng-doc-size=\"24\"][_nghost-%COMP%]{width:var(--ng-doc-icon-width, 24px);height:var(--ng-dpc-icon-height, 24px)}"],
        changeDetection: 0
      });
    }
  }
  return NgDocIconComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgDocIconComponent };
